/**
 * MITO-ORANGE signed-in layout for Basketmouth, Trust, and widget.
 * Same structure as Rhemito MITO-BLUE. Brand hover uses --clr1 (orange on BM).
 */
export const mitoOrangeLayout = {
  pagePx: { sm: "20px", xl: "50px" } as const,
  sidebarGap: 10,
  mainPt: "50px",
  mainPb: "80px",
  sectionMb: "12",
  sectionTitleMb: "6",
  tableCellPx: "6",
  pageTitleSize: {
    sm: "xxxl_light",
    lg: "xxxl_light",
    xl: "Enlarge_light",
  } as const,
  sectionTitleSize: "xxxl_medium" as const,
  brand: "orange.500",
  brandCss: "var(--clr1)",
  creditCardMaxW: "340px",
  creditCardAspect: "1.586",
  fieldControlH: "38px",
  /** Labels: 12px sm. Inputs / selects: 16px lg — see theme/mito/tokens.ts */
  formField: {
    labelColor: "black.200" as const,
    inputVariant: "Simple" as const,
    inputFontSize: "lg" as const,
    inputColor: "black.200" as const,
    borderColor: "#C8C6C4",
    placeholderColor: "#D2D0CE",
  },
  /** Narrow controls — invoice, expiry, payer, file upload */
  fieldNarrowMaxW: { base: "100%", md: "280px" } as const,
  fieldWideMaxW: { base: "100%", md: "480px" } as const,
  quoteBreakdownSidebarW: { base: "100%", lg: "400px" } as const,
  quoteBreakdown: {
    titleSize: "lg" as const,
    rowSize: "md" as const,
    metaSize: "sm" as const,
    noteSize: "md" as const,
  },
  legalStrip: {
    justify: "flex-end" as const,
    align: "center" as const,
    ml: "auto" as const,
    mb: "2.2rem",
    flexWrap: "wrap" as const,
    color: "#605E5C",
  },
};
